export const PRODUCT_SORT: string[] = [
    'product_ps_river_river_mini',
    'product_ps_river_river',
    'product_ps_river_river_max',
    'product_ps_river_river_pro_720',
    'product_ps_river_river_256',
    'product_ps_river_river_512',
    'product_ps_river_river_768',

    'product_ps_delta_delta_mini',
    'product_ps_delta_delta_1300',
    'product_ps_delta_delta_max',
    'product_ps_delta_delta_pro',
    'product_ps_delta_delta_2',
    'product_ps_delta_delta_2_max',

    'product_sp_60w_solar_panel',
    'product_sp_110w_solar_panel',
    'product_sp_160w_solar_panel',
    'product_sp_220w_bi_solar_panel',

    'product_sp_400w_solar_panel',
    'product_sp_400w_rigid_solar_panel',
    'product_sp_100w_rigid_solar_panel',
    'product_sp_100w_flexible_solar_panel',

    'product_st_solar_tracker',
    'product_sg_dg100',
    'product_shp',

    'product_ac_wave',
    'product_sg_dg200',
    'product_ac_kt210',
    'product_fridge_bx100',
    'product_mh100',
];

export const PRODUCT_SORT_NA: string[] = [
    'product_ps_river_river_mini',
    'product_ps_river_river',
    'product_ps_river_river_max',
    'product_ps_river_river_pro_720',
    'product_ps_river_river_256',
    'product_ps_river_river_512',
    'product_ps_river_river_768',

    'product_ps_delta_delta_mini',
    'product_ps_delta_delta_1300',
    'product_ps_delta_delta_max',
    'product_ps_delta_delta_2',
    'product_ps_delta_delta_pro',
    'product_ps_delta_delta_2_max',

    'product_sp_60w_solar_panel',
    'product_sp_100w_rigid_solar_panel',
    'product_sp_100w_flexible_solar_panel',
    'product_sp_400w_rigid_solar_panel',
    'product_sp_110w_solar_panel',
    'product_sp_160w_solar_panel',
    'product_sp_400w_solar_panel',
    'product_sp_220w_bi_solar_panel',

    'product_st_solar_tracker',
    'product_sg_dg100',
    'product_shp',

    'product_ac_wave',
    'product_sg_dg200',
    'product_ac_kt210',
    'product_fridge_bx100',
    'product_mh100',
];

export const POWER_SERIES_SORT: string[] = ['product_ps_river', 'product_ps_delta'];

export const HIDE_PRODUCT: string[] = ['product_ps_river_river_512', 'product_ps_river_river_768'];
